import { h } from 'preact';
import Icon from '../utils/icon';

const Pagination = ({ paginate }) => {
	
  if (!paginate || !paginate?.pages) return null;

  return (
    <nav className="flex items-center justify-between px-4 sm:px-0 pt-8 border-t border-grey-5 pb-8 border-b md:mx-5">
      <div className="flex flex-1 w-0">
        {paginate.previous ? (
          <a href={paginate.previous.url} className="inline-flex items-center pr-1 no-underline uppercase text-secondary font-medium justify-center gap-1.5">
            <span className="w-4 h-4 mx-2">
              <Icon name='arrow-prev' classes='w-4 h-4' />
            </span>
            <span>
              {window.TMW.Strings.pagination.previous}
            </span>
          </a>
        ) : (
          <span className="inline-flex items-center pr-1 no-underline uppercase text-secondary font-medium">
            <span className="w-4 h-4 mx-2">
              <Icon name='arrow-prev' classes='w-4 h-4' />
            </span>
            <span>
              {window.TMW.Strings.pagination.previous}
            </span>
          </span>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex justify-center">
          {paginate.parts.map((part, index) => (
            part.isLink ? (
              <a key={index} href={part.url} className="inline-flex items-center px-px mx-1 no-underline">
                {part.title}
              </a>
            ) : (
              <a href={part.url} key={index} className={`inline-flex items-center px-px mx-1 no-underline ${part.title === paginate.current_page ? 'border-b border-primary font-bold text-primary' : ''}`}>
								{part.title === "&hellip;" ? "..." : part.title}
              </a>
            )
          ))}
        </div>
        <div className="flex justify-center items-center uppercase text-secondary utility-2">
					Showing {Math.min(paginate.page_size * paginate.current_page, paginate.items)}{' '}
					of {paginate.items}
				</div>
      </div>
      <div className="flex justify-end flex-1 w-0">
        {paginate.next ? (
          <a href={paginate.next.url} className="inline-flex items-center pl-1 no-underline uppercase text-secondary font-medium gap-1.5 justify-center">
            <span>
              {window.TMW.Strings.pagination.next}
            </span>
            <span className="w-4 h-4 mr-2 rotate-180">
              <Icon name='arrow-prev'classes='w-4 h-4' />
            </span>
          </a>
        ) : (
          <span className="inline-flex items-center pl-1 no-underline uppercase text-secondary font-medium gap-1 justify-center">
            <span>
              {window.TMW.Strings.pagination.next}
            </span>
            <span className="w-4 h-4 mr-2 rotate-180">
              <Icon name='arrow-prev' classes='w-4 h-4' />
            </span>
          </span>
        )}
      </div>
    </nav>
  );
};

export default Pagination;
